<template>
  <div id="sve" class="d-flex">
    <MainBarMenuV2 />
    <div class="layout-content container-fluid">
      <HeadingUser class="bg-white" />
      <div class="mx-auto my-5 p-0">
        <div class="col-12">
          <Typography text="Indicadores" variant="h1" class="pt-4" />
        </div>
        <div class="my-5 col-12 p-0">
          <div :class="['d-flex align-content-center justify-content-between']">
            <div class="d-flex">
              <Button
                variant="danger"
                v-show="isDisabled"
                small
                pill
                label="Limpiar filtros"
                @click.prevent="clearFilter"
                :disabled="isBusy"
              />
              <Button
                variant="primary"
                small
                pill
                class="ml-2"
                @click.prevent="getIndicators"
                :disabled="isBusy"
                v-show="isDisabled"
              >
                <span class="mr-2">Aplicar filtros</span
                ><b-spinner v-if="isBusy" />
              </Button>
            </div>
          </div>
        </div>
        <div class="filters p-4 position-relative box-shadow">
          <div class="row col-12 mx-0 px-0">
            <div class="col-md-3">
              <Typography
                text="Ciudad"
                variant="CTA"
                color="#5d5fef"
                class="border-filters-title"
              />
              <div class="pt-2 space-y-4">
                <Select
                  label="Ciudad"
                  name="city_id"
                  :options="options.cities"
                  :value="valueFilters.city_id"
                  v-model="valueFilters.city_id"
                />
              </div>
            </div>
            <div class="col-md-3 ml-8">
              <Typography
                text="Estado"
                variant="CTA"
                color="#5d5fef"
                class="border-filters-title"
              />
              <div class="pt-2 space-y-4">
                <Select
                  label="Estado"
                  name="status"
                  :options="options.status"
                  :value="valueFilters.status"
                  v-model="valueFilters.status"
                />
              </div>
            </div>
            <div class="col-md-6 ml-8">
              <Typography
                text="General"
                variant="CTA"
                color="#5d5fef"
                class="border-filters-title"
              />
              <div class="pt-2">
                <div class="row">
                  <div class="col-md-6 space-y-4">
                    <Input
                      label="Demandante"
                      name="demandante"
                      :value="valueFilters.plaintiff_name"
                      @input="
                        (event) =>
                          (valueFilters.plaintiff_name = event.target.value)
                      "
                    />
                    <Select
                      label="Demandado"
                      name="defendants"
                      :options="options.defendants"
                      :value="valueFilters.defendants"
                      v-model="valueFilters.defendants"
                    />
                    <Select
                      label="Juzgado"
                      name="courts"
                      :options="options.courts"
                      :value="valueFilters.court_id"
                      v-model="valueFilters.court_id"
                    />
                    <Select
                      label="Sindicato"
                      name="laborUnion"
                      :options="options.unions"
                      :value="valueFilters.laborUnion"
                      v-model="valueFilters.laborUnion"
                    />
                  </div>
                  <div class="col-md-6 space-y-4">
                    <Select
                      label="Abogado"
                      name="lawyer"
                      :options="options.lawyers"
                      :value="valueFilters.lawyer_id"
                      v-model="valueFilters.lawyer_id"
                    />

                    <Select
                      label="Area"
                      name="area"
                      :options="options.areas"
                      :value="valueFilters.area_id"
                      v-model="valueFilters.area_id"
                    />
                    <Select
                      label="Objeto"
                      name="object"
                      :options="options.objects"
                      :value="valueFilters.object_id"
                      v-model="valueFilters.object_id"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row mb-5">
          <div class="col-lg-4">
            <div class="card_indicator box-shadow p-3">
              <Typography
                text="Sindicatos"
                variant="h2"
                class="p-1 border-bottom"
              />
              <div class="d-flex justify-content-center" v-if="isBusy">
                <b-spinner style="width: 4.5rem; height: 4.5rem;"  />
              </div>
              <div class="d-flex flex-column h-75" v-else>
                <div class="d-flex justify-content-between">
                  <span class="title-card-indicator w-25">Nombre</span>
                  <span class="title-card-indicator">Total Procesos</span>
                  <span class="title-card-indicator">Fav | con</span>
                </div>
                <div
                  class="d-flex justify-content-between"
                  v-for="(v, index) in unions"
                  :key="index"
                >
                  <Typography variant="label" color="#455A64" class="w-25">{{
                    v.name
                  }}</Typography>
                  <span class="black">{{ v.fav + v.con }}</span>
                  <div class="">
                    <span class="cyan">{{ v.fav }}</span>
                    <span class="mr-2 ml-2">|</span>
                    <span class="red">{{ v.con }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-3">
            <div class="card_indicator box-shadow p-3">
              <Typography
                text="Juzgados"
                variant="h2"
                class="p-1 border-bottom"
              />
              <div class="d-flex justify-content-center" v-if="isBusy">
                <b-spinner style="width: 4.5rem; height: 4.5rem;"  />
              </div>
              <div class="d-flex flex-column h-75" v-else>
                <div class="d-flex justify-content-end">
                  <span class="title-card-indicator">Fav | con</span>
                </div>
                <div
                  v-for="(v, index) in courts"
                  :key="index"
                  class="d-flex justify-content-between"
                >
                  <Typography
                    variant="label"
                    color="#455A64"
                    class="truncate w-75"
                    :title="v.name"
                  >
                    {{ v.name }}
                  </Typography>
                  <div class="">
                    <span class="cyan">{{ v.fav }}</span>
                    <span class="mr-2 ml-2">|</span>
                    <span class="red">{{ v.con }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-2">
            <div class="card_indicator box-shadow p-3">
              <Typography text="Áreas" variant="h2" class="p-1 border-bottom" />
              <div class="d-flex justify-content-center" v-if="isBusy">
                <b-spinner style="width: 4.5rem; height: 4.5rem;"  />
              </div>
              <div class="d-flex flex-column h-75" v-else>
                <div class="d-flex justify-content-between">
                  <span class="title-card-indicator">Área</span>
                  <span class="title-card-indicator">Litigio</span>
                </div>
                <div
                  v-for="(v, index) in areas"
                  :key="index"
                  class="d-flex justify-content-between"
                >
                  <Typography
                    variant="label"
                    color="#455A64"
                    class="truncate w-75"
                    :title="v.name"
                    >{{ v.name }}
                  </Typography>
                  <div class="">
                    <span class="black">{{ v.value }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-3">
            <div class="card_indicator box-shadow p-3">
              <Typography
                text="Top Ciudades"
                variant="h2"
                class="p-1 border-bottom"
              />
              <div class="d-flex justify-content-center" v-if="isBusy">
                <b-spinner style="width: 4.5rem; height: 4.5rem;"  />
              </div>
              <div class="d-flex flex-column h-75" v-else>
                <div class="d-flex justify-content-end">
                  <span class="title-card-indicator">Ciudad</span>
                  <span class="title-card-indicator">Litigio</span>
                </div>
                <div
                  v-for="(v, index) in cities"
                  :key="index"
                  class="d-flex justify-content-between"
                >
                  <Typography
                    variant="label"
                    color="#455A64"
                    class="truncate w-75"
                    :title="v.name"
                    >{{ v.name }}
                  </Typography>
                  <div class="">
                    <span class="black">{{ v.value }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-6">
            <div class="card_indicator box-shadow p-3">
              <Typography
                text="Resultados por Instancia"
                variant="h2"
                class="p-1 border-bottom"
              />
              <div class="d-flex justify-content-center" v-if="isBusy">
                <b-spinner style="width: 4.5rem; height: 4.5rem;"  />
              </div>
              <div v-else>
                <div v-for="(v, index) in status" :key="index">
                  <Typography variant="label" class="mb-0"
                    >{{ v.name
                    }}<span
                      :class="[
                        'float-right',
                        v.id === 'pri'
                          ? 'orange'
                          : v.id === 'sgd'
                          ? 'purple'
                          : 'blue',
                      ]"
                      >{{ v.value }}</span
                    ></Typography
                  >
                  <b-progress
                    :value="v.percentage"
                    :max="100"
                    :class="[
                      'mb-4',
                      v.id === 'pri'
                        ? 'color-orange'
                        : v.id === 'sgd'
                        ? 'color-purple'
                        : 'color-blue',
                    ]"
                  ></b-progress>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-6">
            <div class="card_indicator box-shadow p-3">
              <Typography
                text="Resultados"
                variant="h2"
                class="p-1 border-bottom"
              />
              <div class="d-flex justify-content-center" v-if="isBusy">
                <b-spinner style="width: 4.5rem; height: 4.5rem;"  />
              </div>
              <div class="d-flex" v-else>
                <BarChart
                  :chart-data="chartData?.barchart"
                  :options="chartOptions?.barchart"
                  cssClasses="chartLegal col-9"
                />
                <div class="col-3 border-left overflow-auto h-400px">
                  <Typography
                    v-for="(v, index) in results.labels"
                    :key="index"
                    :text="chartData?.barchart?.labels[index] + ' - ' + v"
                    variant="label"
                    color="#455A64"
                    class="overflow-ellipsis truncate"
                    :title="v"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import useControllers from "@/controllers";
const { useScreenHooks } = useControllers();
const { useLegal } = useScreenHooks();
const { useIndicator } = useLegal();

export default useIndicator;
</script>

<style scope>
.title-card-indicator {
  color: #b0bec5 !important;
  font-size: 12px !important;
}
.subtile-indicator {
  font-size: 12px !important;
  color: #455a64 !important;
  font-weight: 400 !important;
  margin-bottom: 0px !important;
}
.box-shadow {
  box-shadow: 0 0rem 0.5rem rgba(0, 0, 0, 0.175) !important;
}
.bg__white {
  background: #ffffff !important;
  margin-bottom: 30px !important;
}
.bg-indicators {
  /* background: #ECEFF1; */
  background: white;
}
.card_indicator {
  background: rgba(255, 255, 255, 0.88);
  border-radius: 12px;
  max-height: 500px;
}
.chartLegal {
  max-height: 100%;
}

.progress-bar {
  border-radius: 50px;
}

.progress.color-blue {
  background-color: #ccf8fe;
  border-radius: 50px;
}
.progress.color-purple {
  background-color: #b6b0fa;
  border-radius: 50px;
}
.progress.color-orange {
  border-radius: 50px;
  background-color: #fff5cc;
}
.color-purple .progress-bar {
  background-color: #4339f2;
}
.color-orange .progress-bar {
  background-color: #ffb200;
}
.color-blue .progress-bar {
  background-color: #02a0fc;
}
.purple {
  color: #4339f2;
}
.blue {
  color: #02a0fc;
}
.orange {
  color: #ffb200;
}
.cyan {
  color: #2ebfca;
  font-weight: 700 !important;
}
.red {
  color: #e22613;
  font-weight: 700 !important;
}
.h-400px {
  height: 400px;
}
.filters {
  border-radius: 12px;
}
.space-y-4 {
  & > div:not(:first-child) {
    margin-top: 1rem;
  }
}
</style>
